export default "/images/vendor/flag-icon-css/flags/1x1/lb.svg?ede59c1723abcf425c23e0c8f1dfb20a";